(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["maxcom-offers"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(){
const root=document.getElementById('max-offers');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const grid=root.querySelector('.mof-grid'),input=root.querySelector('#mof-query'),sort=root.querySelector('[data-sort]'),status=root.querySelector('[data-status]'),empty=root.querySelector('.mof-empty'),loading=root.querySelector('.mof-loading');
let selected='all',busy=false;
const norm=s=>s.toLocaleLowerCase('bs').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/đ/g,'dj');
function apply(){
 const terms=norm(input.value).trim().split(/\s+/).filter(Boolean);
 const cards=Array.from(grid.querySelectorAll('.mof-card'));
 cards.sort((a,b)=>sort.value==='name'?a.dataset.title.localeCompare(b.dataset.title,'bs'):Number(b.dataset.date)-Number(a.dataset.date));
 let count=0;for(const card of cards){grid.appendChild(card);const hay=norm(card.dataset.title+' '+card.dataset.handle);const show=(selected==='all'||card.dataset.categories.split(' ').includes(selected))&&terms.every(t=>hay.includes(t));card.hidden=!show;if(show)count++;}
 status.textContent=count+' / '+cards.length;empty.hidden=count>0||busy;
}
root.querySelector('.mof-search').addEventListener('submit',e=>{e.preventDefault();apply()});
input.addEventListener('input',apply);sort.addEventListener('change',apply);
root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{selected=b.dataset.filter;root.querySelectorAll('[data-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));apply()}));
async function loadMore(){
 let link=root.querySelector('.mof-next');if(!link){apply();return;}
 busy=true;loading.hidden=false;
 const seen=new Set();
 try{
 while(link){
  const url=new URL(link.href,location.origin);if(url.origin!==location.origin||seen.has(url.href))break;seen.add(url.href);
  const params=new URLSearchParams(location.search);if(params.has('preview_theme_id'))url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
  url.searchParams.set('section_id',root.dataset.section);
  const response=await fetch(url.href,{credentials:'same-origin'});if(!response.ok)throw new Error('load');
  const doc=new DOMParser().parseFromString(await response.text(),'text/html');const nextRoot=doc.querySelector('#max-offers');if(!nextRoot)throw new Error('section');
  const handles=new Set(Array.from(grid.children).map(c=>c.dataset.handle));
  nextRoot.querySelectorAll('.mof-card').forEach(c=>{if(!handles.has(c.dataset.handle))grid.appendChild(c)});
  const next=nextRoot.querySelector('.mof-next');if(next){link.href=next.href}else{link.remove();link=null}apply();
 }
 }catch(e){if(link)link.hidden=false;}
 busy=false;loading.hidden=true;apply();
}
apply();loadMore();
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();
})();
